import MdaeAddButton from "./component";
import { IButtonOptions } from "devextreme-react/button";
export default MdaeAddButton;
export interface IMdaeAddButtonProps extends IButtonOptions {
  id: string;
  title: string;
}
